import { version } from '@/config'
import storejs from 'store'

const watch = store => {
  store.watch(
    state => state.bitRate,
    bitRate => {
      if (bitRate) {
        store.dispatch('fetchVideoYaml').catch(() => {
          store.commit('setLoading', false)
        })
      }
    },
  )
  // watch tar id
  store.watch(
    state => state.tarId,
    tarId => {
      if (tarId) {
        store.commit('resetBitRate')
        store.dispatch('fetchTarInfo').catch(() => {
          store.commit('setLoading', false)
        })
      }
    },
  )
  store.watch(
    (state, getter) => getter.tarUrl,
    tarId => {
      if (tarId) {
        store.commit('resetBitRate')
        store.dispatch('fetchCameraList').catch(() => {
          store.commit('setLoading', false)
        })
      }
    },
  )
  store.watch(
    (state, getter) => getter.cameraId,
    cameraId => {
      if (cameraId >= 0) {
        store.commit('resetBitRate')
        store.dispatch('fetchVideoYaml').catch(() => {
          store.commit('setLoading', false)
        })
        if (store.state.showRealtimeShieldManually) {
          store.dispatch('fetchRealtimeManuallyShieldConfig').catch(() => {
            store.commit('setLoading', false)
          })
        }
        if (store.state.showRealtimeShieldLine) {
          store.dispatch('fetchRealtimeLineShieldConfig').catch(() => {
            store.commit('setLoading', false)
          })
        }
      }
    },
  )
  version === '2' &&
    store.watch(
      state => state.videoUrl,
      videoUrl => {
        if (videoUrl !== '') {
          store.dispatch('loadAndDecodeVideo')
        }
      },
    )
  store.watch(
    state => state.frameCount,
    length => {
      // eslint-ignore-next-line
      if (storejs.get('playControl:autoPlay')) {
        setTimeout(() => {
          store.state.isPlaying = true
        }, 500)
      }
      store.commit('setFrameIdx', 0)
    },
  )
  store.watch(
    state => state.yamlUrl,
    url => {
      url &&
        store.dispatch('fetchDetectInfo').catch(() => {
          store.commit('setLoading', false)
        })
    },
  )
  store.watch(
    state => state.shieldUrl,
    () => {
      store.dispatch('fetchShieldInfo').catch(() => {
        store.commit('setLoading', false)
      })
    },
  )
  store.watch(
    state => state.showRealtimeShieldManually,
    val => {
      if (val) {
        store.dispatch('fetchRealtimeManuallyShieldConfig').catch(() => {
          store.commit('setLoading', false)
        })
      }
    },
  )
  store.watch(
    state => state.showRealtimeShieldLine,
    val => {
      if (val) {
        store.dispatch('fetchRealtimeLineShieldConfig').catch(() => {
          store.commit('setLoading', false)
        })
      }
    },
  )
  store.watch(
    state => state.preloading.cached,
    val => {
      storejs.set('preloading:cached', val)
    },
  )
}

export default {
  watch,
}
